<!--
//================================================================================
// ID:-
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:CautionItem
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/08/06 | 富士通株式会社         | 新規作成
// 01.02.00 | 2024/03/29 | 富士通Japan株式会社    | 令和5年度改修対応（3次リリース）
//================================================================================
-->
<template>
	<div class="contents__information div-tyuimargin" :class="[classDiv != '' ? classDiv : '']">
		<div class="div-paddingbottom">
			<font-awesome-icon icon="exclamation-triangle" />
			<label class="label-tyuijikou">注意事項</label>
		</div>
		<div class="div-tyuibunItem">
			<div>
				<div
					v-for="(item, index) in cautionMessagelist"
					:key="index"
					class="div_row contents__caution--multiple"
				>
					<label class="contents__caution--multiple">
						{{ item }}
					</label>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { co_post } from '@/common/ajaxUtility.js';
import { co_isEmpty } from '@/common/checkUtility.js'

import { API_CAUTION_ITEMS } from '@/const/route.js';

export default {
	inheritAttrs: false,
	props: {
		tyuibunItems: {type: Array, default: function() {
				return []
			}
		},
		classDiv: {type: String, default: ''},			// 注意文エリアのスタイル
	},
	data: function() {
		return {
			cautionMessagelist: []
		}
	},
	watch: {
		tyuibunItems: async function () {

			this.cautionMessagelist = [];

			if(!co_isEmpty(this.tyuibunItems))	{
				// 親から受け取った注意文番号で注意文を生成
				this.createList(await this.getData());
			}
		},
	},
	created: async function() {
		if (!co_isEmpty(this.tyuibunItems))	{
			// 親から受け取った注意文番号で注意文を生成
			this.createList( await this.getData() );
		}
	},
	methods: {
		// 注意文マスタより注意文情報を取得
		getData: function() {
			let params = [];
			if (!co_isEmpty(this.tyuibunItems))	{
				params = {tyuibunList: this.tyuibunItems};
			}
			// ajaxにてサーバーと通信
			return co_post( API_CAUTION_ITEMS, params );
		},
		// リスト作成
		createList: function( val ) {

			let cautionMessagelist = [];

			if ( val != null ) {
				for ( let i = 0; i < val.length; i++ ) {
					let sentenceList = [];		// メッセージリスト
					let message = [];			// 画面表示用メッセージ

					sentenceList = val[i].messageNaiyo.split(/\r\n|\n/);
					for ( let j = 0; j < sentenceList.length; j++ ) {
						message.push(sentenceList[j]);
					}
					cautionMessagelist = message;
				}
				this.cautionMessagelist = cautionMessagelist;
			}
		},
	}
}

</script>

<style scoped>
.div-tyuimargin {
	margin-left: 2%;
	margin-right: 2%;
}
.div-paddingbottom {
	padding-bottom: 20px;
}

/* 端末がPCの場合 */
@media screen and (min-width: 768px) {
	.label-tyuijikou {
		font-size: 20px;
		margin-left: 1%;
	}
	.div-tyuibunItem {
		margin-left: 3%;
		margin-top: -13px;
	}
}

/* 端末がスマホの場合 */
@media screen and (max-width: 767px) {
	.label-tyuijikou {
		font-size: 18px;
		margin-left: 1%;
	}
	.div-tyuibunItem {
		margin-top: -13px;
	}
}
</style>